import { render, staticRenderFns } from "./AnalysisTypePage.vue?vue&type=template&id=3b6855e6"
import script from "./AnalysisTypePage.vue?vue&type=script&lang=js"
export * from "./AnalysisTypePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports